import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormArray, FormGroup, FormControl } from "@angular/forms";
import "ag-grid-angular";

import "ag-grid-angular";
import 'ag-grid-community/dist/styles/ag-grid.css';

@Component({
  selector: 'merchant-support-request',
  templateUrl: './merchant-support-request.component.html'
})
export class MerchantSupportRequest implements OnInit {
  supportForm: FormGroup<{
    contactPerson: FormControl<string>,
    contactNo: FormControl<string>,
    issue: FormControl<string>,
    remarks: FormControl<string>,
    priority: FormControl<boolean>,
    isFieldSupport: FormControl<string>
  }>;
  submitted = false;
  columnDefs: any[] = [];
  rowData = [];
  editMode!: true;
  BankBranchEditForm!: UntypedFormGroup;
  showModelEditBox: boolean = false;
  loadingIndicator!: boolean;
  date: any;
  issueType = [
    { value: 1, text: 'Accessories' },
    { value: 2, text: 'Hardware Issue' },
    { value: 3, text: 'Operation Assistance' },
    { value: 4, text: 'Power Issue' },
    { value: 5, text: 'Settlement Issue' },
    { value: 6, text: 'Technical Issue' }
  ];
  constructor(private formBuilder: UntypedFormBuilder) {
    this.supportForm = this.formBuilder.group({
      contactPerson: ['', [Validators.required]],
      contactNo: ['', [Validators.required]],
      issue: ['', [Validators.required]],
      remarks: [''],
      priority: [false, [Validators.required]],
      isFieldSupport: ['', [Validators.required]],
    });
  }

  ngOnInit() {
    
  }

  get f() { return this.supportForm.controls; }


}

